import { expression } from "./index.js";
import { is_sql_mappable, is_int_expr, } from "../ap214_functions.js";
/* This is generated code, don't modify */
import EntityTypesAP214 from "./entity_types_ap214.gen.js";
///**
// *  */
export class numeric_expression extends expression {
    get type() {
        return EntityTypesAP214.NUMERIC_EXPRESSION;
    }
    get is_int() {
        return is_int_expr(this);
    }
    get sql_mappable() {
        return is_sql_mappable(this);
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
numeric_expression.query = [EntityTypesAP214.LENGTH_FUNCTION, EntityTypesAP214.VALUE_FUNCTION, EntityTypesAP214.NUMERIC_VARIABLE, EntityTypesAP214.INT_LITERAL, EntityTypesAP214.REAL_LITERAL, EntityTypesAP214.INT_NUMERIC_VARIABLE, EntityTypesAP214.REAL_NUMERIC_VARIABLE, EntityTypesAP214.ABS_FUNCTION, EntityTypesAP214.MINUS_FUNCTION, EntityTypesAP214.SIN_FUNCTION, EntityTypesAP214.COS_FUNCTION, EntityTypesAP214.TAN_FUNCTION, EntityTypesAP214.ASIN_FUNCTION, EntityTypesAP214.ACOS_FUNCTION, EntityTypesAP214.EXP_FUNCTION, EntityTypesAP214.LOG_FUNCTION, EntityTypesAP214.LOG2_FUNCTION, EntityTypesAP214.LOG10_FUNCTION, EntityTypesAP214.SQUARE_ROOT_FUNCTION, EntityTypesAP214.MINUS_EXPRESSION, EntityTypesAP214.DIV_EXPRESSION, EntityTypesAP214.MOD_EXPRESSION, EntityTypesAP214.SLASH_EXPRESSION, EntityTypesAP214.POWER_EXPRESSION, EntityTypesAP214.ATAN_FUNCTION, EntityTypesAP214.PLUS_EXPRESSION, EntityTypesAP214.MULT_EXPRESSION, EntityTypesAP214.MAXIMUM_FUNCTION, EntityTypesAP214.MINIMUM_FUNCTION];
numeric_expression.expectedType = EntityTypesAP214.NUMERIC_EXPRESSION;
